// Onedot6 — luxury editorial design tokens (web).
export const LUX = {
  bg: "#F7F5F0",
  surface: "#FFFFFF",
  ink: "#1C1B1A",
  sec: "#57534E",
  muted: "#8C8579",
  accent: "#8C7B65",
  line: "#E7E5E4",
  lineStrong: "#D6D3D1",
};

export const NAV_ITEMS = [
  { label: "Home", href: "/" },
  { label: "Projects", href: "/projects" },
  { label: "The Work", href: "/bespoke" },
  { label: "Experience Center", href: "/experience" },
  { label: "Journal", href: "/journal" },
  { label: "Contact", href: "/contact" },
];
